import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LuEye } from "react-icons/lu";
import Loading from "../Modals/Loading";
import packingService from "../Services/packingService";

const PackingList = () => {
  const [packings, setPackings] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const loadPackings = async () => {
      try {
        setLoading(true);
        const data = await packingService.getAll();
        setPackings(data.packings || []);
      } catch (error) {
        console.error("Error fetching packings:", error);
      } finally {
        setLoading(false);
      }
    };

    loadPackings();
  }, []);

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      {loading ? (
        <Loading />
      ) : (
        <div>
          <div>
            <h1 className="font-bold text-3xl text-secondary mb-4">
              Packing List
            </h1>
          </div>
          <div className="table-div">
            <table className="w-full">
              <thead className="border-y-2 text-center text-black text-[10px]">
                <tr>
                  <th className="text-center py-3 w-[1%]">ID</th>
                  <th className="text-center py-3 w-[2%]">Sale ID</th>
                  {/* <th className="text-center py-3 w-[1%]">
                    Customer Invoice #
                  </th> */}
                  <th className="text-center py-3 w-[2%]">Reference</th>
                  <th className="text-center py-3 w-[6%]">Customer</th>
                  <th className="text-center py-3 w-[2%]">Date</th>
                  <th className="text-center py-3 w-[4%] ">Status</th>
                  <th className="text-center py-3 w-[2%] rounded-tr-lg">
                    View
                  </th>
                </tr>
              </thead>

              <tbody>
                {packings.map((value, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 text-[11px]"
                  >
                    <td className="py-3 text-center text-blue-500 font-bold">
                      {value.id}
                    </td>
                    <td className="py-3 text-center">{value.order}</td>
                    <td className="py-3 text-center">
                      {value.customer_order_number
                        ? value.customer_order_number
                        : "-"}
                    </td>

                    <td className="py-3 text-center font-semibold">
                      {value.company_name}
                    </td>

                    <td className="py-3 text-center">
                      {moment(value.date).format("ll")}
                    </td>

                    <td className="py-3 text-center">
                      <span
                        className={`py-1 px-2 rounded-md uppercase text-center font-semibold ${
                          value.order_status === "Pending"
                            ? "bg-red-500 bg-opacity-20 text-red-500"
                            : value.order_status === "Completed"
                              ? "bg-green-500 bg-opacity-20 text-green-500"
                              : "bg-yellow-500 bg-opacity-20 text-yellow-500"
                        }`}
                      >
                        {value.order_status}
                      </span>
                    </td>

                    {/* ✅ View Button */}
                    <td className="py-3 px-2 text-center">
                      <button
                        className="rounded-md text-indigo-600 hover:text-indigo-800"
                        onClick={() => navigate(`/packing/view/${value.id}`)}
                      >
                        <LuEye className="h-4 w-4 text-sky-600" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </main>
  );
};

export default PackingList;
